export default __webpack_public_path__ + "static/media/transport.bea62b8e.svg";